import React from 'react'
import Lottie from 'react-lottie'
import animationData from './animationData.json'


export default function ConfirmationMessage({ isVisible }) {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
  }
  return (
    <>
      {isVisible && (
        
            <Lottie options={defaultOptions} style={{ maxHeight: '70px', maxWidth: '70px' }} />
          
      )}
    </>
  )
}
